import { render, staticRenderFns } from "./CostStructure.vue?vue&type=template&id=c45b125e&scoped=true&"
import script from "./CostStructure.vue?vue&type=script&lang=js&"
export * from "./CostStructure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45b125e",
  null
  
)

export default component.exports